import { ReactSortable } from 'react-sortablejs';
import { PlusOutlined } from '@ant-design/icons';
import './index.scss';
import { DimensionItem } from './dimension_item';
import { useActionHandle } from '../useActionHandle';
import { Button } from 'tea-component';
import React, { useMemo } from 'react';
import type { IColumnInfo } from '@dbl/core/dataSource';
import {deepClone, useDblIntl} from '@/pages/datalab/utils/utils';
import { getFirstColumn, getFlatOptions } from '../../utils';
import SvgIcon from '@/pages/home/components/SvgIcon';

export function DimensionEdit(props: {
  columns: IColumnInfo[];
  allDimensions: any[];
  optionDimensions: any[];
  dispatchFun: Function;
}) {
  const { columns, allDimensions, optionDimensions, dispatchFun } = props;
  const notifyFun = (columnDimensions: IColumnInfo[]) => {
    dispatchFun({
      payload: { columnDimensions },
    });
  };
  const { dblFormatMessage: explorationFormatMessage} = useDblIntl("exploration");
  const handle = useActionHandle(columns, notifyFun);
  const { addItem, setItems } = handle;
  const selectedItems = useMemo(() => columns.map((item) => item.column_name), [JSON.stringify(columns)]);

  return (
    <>
      <ReactSortable
        className='context-four'
        list={columns}
        setList={(list: IColumnInfo[]) => {
          setItems(list);
        }}
        // handle=".icon_drop"
      >
        {(columns || []).map((column, index) => (
          <DimensionItem
            key={`${column.table_id}.${column.column_name}`}
            optionDimensions={optionDimensions}
            column={column}
            index={index + 1}
            handle={handle}
            selectedItems={selectedItems}
            onSelectItem={(newItemName: string) => {
              const newColumn = allDimensions.find((item: IColumnInfo) => item.column_name === newItemName);
              if (!newColumn || newColumn.column_name === column.column_name) {
                return;
              }
              const list = [
                ...columns.slice(0, index),
                { ...deepClone(newColumn) },
                ...columns.slice(index + 1, columns.length),
              ];
              setItems(list);
            }}
          />
        ))}
      </ReactSortable>
      <span
        className="add-box"
        onClick={() => {
          const flatOptions = getFlatOptions(optionDimensions);
          const newColumn = getFirstColumn(allDimensions, columns, flatOptions);
          if (!newColumn) {
            return;
          }
          addItem(newColumn);
        }}
      >
        <SvgIcon type="add-bg-icon" className="add-box-icon" />
        <span className="add-box-text">{explorationFormatMessage("add_dimension")}</span>
      </span>
    </>
  );
}
